<div id="wrapper">
  <app-top-menu />
  <router-outlet />
  <app-footer />
</div>
